export type BaseLayerId = "google-satellite" | "google-hybrid" | "google-streets" | "osm";

export type DrawMode = "none" | "Point" | "LineString" | "Polygon" | "Rectangle" | "Circle";

export type InteractionMode =
  | "select"
  | "modify"
  | "translate"
  | "draw"
  | "measure-distance"
  | "measure-area"
  // Fluxo B do plano multicanal (§5): CREATE_TREE_MODE. Nao desenha uma feicao
  // de rascunho do editor — marca a posicao de um exemplar arboreo, que e
  // cadastrado pelo FIQ-1.
  | "create-tree";

export interface EditorFeatureAttrs {
  featureId: string;
  rascunhoId: string | null;
  camadaDestino: string;
  tipoObjeto: string;
  tipoGeometria: string;
  status: string;
  propriedades: Record<string, unknown>;
  isNew: boolean;
  isDirty: boolean;
}

export interface MeasurementResult {
  type: "distance" | "area";
  value: number;
  label: string;
}

export const BASE_LAYER_LABELS: Record<BaseLayerId, string> = {
  "google-satellite": "Google Satélite",
  "google-hybrid": "Google Híbrido",
  "google-streets": "Google Streets",
  osm: "OpenStreetMap",
};
